import { WriteSubordinate } from "@/types/structure-assignment";

export const createEmptySubordinate = (): WriteSubordinate => ({
  subordinate_id: "",
  is_primary: false,
  comment: "",
});
